import * as yup from 'yup';
import {
  MAX_PRODUCT_NAME_LENGTH,
  MIN_PRODUCT_NAME_LENGTH,
} from '../../constants/validationConstants';
import { apiCreateFilterOption } from '../../helpers/api';
import { dispatcher } from '../../helpers/projectHelper';
import { updateFilter } from '../../redux/slicers/filters/filterSlicer';

export const nameSchema = {
  name: yup.string().min(MIN_PRODUCT_NAME_LENGTH).max(MAX_PRODUCT_NAME_LENGTH).required(),
};

export const getNameFields = (data) => [
  {
    name: 'name',
    placeholder: 'Room name',
    value: data.name,
  },
];

export const getProjectTypeFields = (data, options) => [
  {
    name: 'room_type',
    placeholder: 'Type of project',
    value: data.room_type,
    type: 'select',
    selectProps: { options },
  },
];

export const getCategoryFields = (filter, categoryValue) => {
  const name = `filter_${filter.id}`;

  const schema = {
    [name]: yup.array(),
  };

  // Commented out required validation - all category fields are now optional
  // const schema = {
  //   [name]: yup
  //     .array()
  //     .typeError(`${filter.label_name} is required`)
  //     .test('missing filter', `${filter.label_name} is required`, (arr) => arr && arr.length !== 0),
  // };

  return {
    schema,
    fieldsConfig: [
      {
        name: name,
        placeholder: filter.label_name,
        type: 'select',
        value: categoryValue,

        selectProps: {
          options: filter.options,
          isSearchable: true,
          isMulti: true,
          creatable: true,
          components: {
            DropdownIndicator: null,
          },
          onCreateOption: async (newOptionName) => {
            const result = await apiCreateFilterOption({ filterId: filter.id, options: [newOptionName]})
            if (result?.id && result?.options) {
              dispatcher(updateFilter(result));
              const newOption = result.options.find(o => o.name.toLowerCase() === newOptionName.toLowerCase())
              return { value: newOption.id, label: newOption.name }
            }

            return 
          }
        },
      },
    ],
  };
};


export const getTagsFields = (tagsValue, loadSearchTagOptions, handleCreateTag) => {
  const name = 'tags';

  const schema = {
    [name]: yup.array()
  };

  return {
    schema,
    fieldsConfig: [
      {
        name: name,
        placeholder: 'Tags',
        type: 'select',
        value: tagsValue,

        selectProps: {
          loadOptions: loadSearchTagOptions,
          isSearchable: true,
          isMulti: true,
          creatable: true,
          onCreateOption: handleCreateTag,
          additional: {
            page: 1,
          },
          components: {
            DropdownIndicator: null,
          },
        },
      },
    ],
  };
};